import { invenioConfig } from "@config";
import _merge from "lodash/merge";

export const uiSchema = (title) => {
  const _uiSchema = {
    provider_pid: {
      "ui:options": "hidden",
    },
    notes: {
      "ui:widget": "textarea",
      "ui:help": "Required if Remarks is set to 'DAMAGED' or 'DEFECTIVE'",
    },
    status: {
      "ui:widget": "select",
    },
    cancel_reason: {
      "ui:options": {
        rows: 3,
      },
      "ui:help": "Required if Status is set to 'CANCELLED'",
    },
    received_date: {
      "ui:widget": "date",
      "ui:help": "Required if Status is set to 'RECEIVED'",
    },
    remarks: {
      "ui:widget": "vocabulary",
      "ui:options": {
        vocabularyType: invenioConfig.VOCABULARIES.acqOrders.acq_remarks,
      },
    },
    grand_total: {
      currency: {
        "ui:widget": "vocabulary",
        "ui:options": {
          vocabularyType: invenioConfig.VOCABULARIES.currencies,
        },
      },
      "custom:grid": [
        {
          currency: 6,
          value: 10,
        },
      ],
    },
    grand_total_main_currency: {
      "custom:grid": [
        {
          currency: 6,
          value: 10,
        },
      ],
    },
    cost: {
      "ui:widget": "updown",
      "ui:emptyValue": undefined,
      "ui:options": {
        inputType: "number",
        step: 0.01,
      },
      "ui:placeholder": "Enter cost in Pesos",
    },
    supplier: {
      "ui:widget": "text",
      "ui:placeholder": "Enter supplier name",
      "ui:emptyValue": undefined,
      "ui:options": {
        autoComplete: "on",
      },
    },
    total_cost: {
      "ui:widget": "updown",
      "ui:options": {
        inputType: "number",
        step: 0.01,
      },
      "ui:placeholder": "0.00",
    },
    funds: {
      "ui:options": {
        orderable: false,
      },
    },
    purchase_type: {
      "ui:widget": "vocabulary",
      "ui:options": {
        vocabularyType:
          invenioConfig.VOCABULARIES.acqOrders.acq_order_line_purchase_type,
      },
    },
    payment: {
      mode: {
        "ui:widget": "vocabulary",
        "ui:options": {
          vocabularyType: invenioConfig.VOCABULARIES.acqOrders.acq_payment_mode,
        },
      },
      debit_cost: {
        currency: {
          "ui:widget": "vocabulary",
          "ui:options": {
            vocabularyType: invenioConfig.VOCABULARIES.currencies,
          },
        },
        "custom:grid": [
          {
            currency: 6,
            value: 10,
          },
        ],
      },
      debit_cost_main_currency: {
        "custom:grid": [
          {
            currency: 6,
            value: 10,
          },
        ],
      },
      debit_note: {
        "ui:widget": "textarea",
      },
      "custom:grid": [
        {
          // mode: 5,
          // debit_date: 5,
          // internal_purchase_requisition_id: 6,
        },
      ],
    },

    document_pid: {
      "ui:widget": "referencedDocument",
    },
    medium: {
      "ui:widget": "vocabulary",
      "ui:options": {
        vocabularyType: invenioConfig.VOCABULARIES.acqOrders.acq_medium,
      },
    },
    patron_pid: {
      "ui:widget": "referencedPatron",
    },

    document_details: {
      "custom:grid": [],
    },

    acq_details: {
      "custom:grid": [],
    },

    receiving_details: {
      "custom:grid": [],
    },

    order_lines: {
      "ui:options": "hidden",
    },
    "custom:grid": [
      {
        document_details: 16,
      },
      { document_pid: 10, medium: 6 },
      {
        "custom:divider": 16,
      },
      { acq_details: 16 },
      { status: 8, cancel_reason: 8 },
      {
        remarks: 8,
        purchase_type: 8,
      },
      {
        cost: 5,
        supplier: 6,
        total_cost: 5,
      },
      {
        "custom:divider": 16,
      },
      {
        receiving_details: 16,
      },
      { patron_pid: 7, received_date: 5, copies_received: 4 },
      {
        notes: 16,
      },
    ],
    "custom:root": {
      "custom:formTitle": title,
    },
  };

  const mergedSchema = _merge(
    _uiSchema,
    invenioConfig.ACQ_ORDERS.editorUiSchema
  );

  if (mergedSchema.cancel_reason) {
    mergedSchema.cancel_reason = {
      ..._uiSchema.cancel_reason,
      "ui:disabled": false,
    };
  }
  if (mergedSchema.received_date) {
    mergedSchema.received_date = {
      ..._uiSchema.received_date,
      "ui:disabled": false,
    };
  }

  return mergedSchema;
};
